import SFetch from '@app/utils/sfetch'

export default {
  getTagCloud(workflowId, ledgerId) {
    const url = Silverfin.Routes.tag_cloud_ledger_workflow_review_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      ledgerId,
      workflowId
    )

    return SFetch.jsonWithAlert(url)
  },
}
